exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.alert {\n    padding: 7px;\n}\n.hideBtn {\n    margin: 0;\n    float: right;\n}\n#select-pages {\n    max-width: 300px;\n}\n#fileinput-btn {\n    height: 70px;\n    width: 300px;\n}\n#fileinput {\n    padding-top: 21px;\n    height: 100%;\n}\n.import-list li {\n    margin-left: 20px;\n}\nh3 {\n    font-size: 20px;\n}\n#divider {\n    margin-top: 25px;\n    margin-bottom: 15px;\n}\n\n", ""]);

// exports
